import { useMutation } from 'react-query';
import { locationDao } from 'shared/dao/locationDao';
import { IAddressRequestPayload } from 'shared/interfaces/IAddress';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';

const {
  createLocation: createLocationDao,
  updateLocation: updateLocationDao,
  deleteLocation: deleteLocationDao,
} = locationDao();
export const locationService = () => {
  const createLocation = () => {
    return useMutation((payload: IAddressRequestPayload) => createLocationDao(payload));
  };

  const updateLocation = () => {
    return useMutation<
      IAddressRequestPayload,
      IAxiosErrorResponse,
      { locationId: string; payload: IAddressRequestPayload }
    >(({ locationId, payload }) => updateLocationDao(locationId, payload));
  };

  const deleteLocation = () => {
    return useMutation(({ locationId }: { locationId: string }) => deleteLocationDao(locationId));
  };

  return {
    createLocation,
    updateLocation,
    deleteLocation,
  };
};
